export const ADD_WEAR_THE_TREND_SUCCESS = "ADD_WEAR_THE_TREND_SUCCESS";
export const LIST_ALL_WEAR_THE_TREND_SUCCESS = "LIST_ALL_WEAR_THE_TREND_REQUEST_SUCCESS";
export const UPDATE_WEAR_THE_TREND_SUCCESS = "UPDATE_WEAR_THE_TREND_SUCCESS";
export const LIST_ALL_WEAR_THE_TREND_REQUEST = "LIST_ALL_WEAR_THE_TREND_REQUEST";
export const LIST_ALL_WEAR_THE_TREND_FAILURE = "LIST_ALL_WEAR_THE_TREND_FAILURE";
export const DELETE_WEAR_THE_TREND_SUCCESS = "DELETE_WEAR_THE_TREND_SUCCESS";
export const CREATE_WEAR_THE_TREND_SUCCESS = "CREATE_WEAR_THE_TREND_SUCCESS";
export const LOADING_TRUE = "LOADING_TRUE";
export const LOADING_FALSE = "LOADING_FALSE";
